import React, { Component } from 'react';
import HomeLayout from './layouts/HomeLayout';

export default class Home extends Component {

  constructor(props) {
		super(props);
		this.redirect = this.redirect.bind(this);
	}

  redirect(url) {
    this.props.router.push(url);
  }

  render() {
		return (
      <HomeLayout redirect={this.redirect}></HomeLayout>
    );
	}
}



// WEBPACK FOOTER //
// ./src/Home.js